import common from './common.json';
import menu from './menu.json';
import pms from './pms.json';
import pmc from './pmc.json';
import oms from './oms.json';
import ums from './ums.json';
import cms from './cms.json';
import sms from './sms.json';
import sys from './sys.json';
import others from './others.json';

export default {
  ...common,
  ...menu,
  ...pms,
  ...pmc,
  ...oms,
  ...ums,
  ...cms,
  ...sms,
  ...sys,
  ...others
};



// WEBPACK FOOTER //
// ./src/lang/ja/index.js